import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { evProductDimensionSelected } from 'events/product';

import { trackError } from 'helpers/ErrorUtils';
import ProductUtils from 'helpers/ProductUtils';
import { trackEvent } from 'helpers/analytics';
import AddToCart from 'components/productdetail/stylepicker/AddToCart';
import ColorChooser from 'components/productdetail/stylepicker/ColorChooser';
import SizingChooser from 'components/productdetail/stylepicker/SizingChooser';
import marketplace from 'cfg/marketplace.json';
import { track } from 'apis/amethyst';

const { pdp: { addToCartText, lowStockMessage, sizingPlaceholder, showStyleChooserPrefix } } = marketplace;

class StylePicker extends Component {

  static contextTypes = {
    testId: PropTypes.func
  };

  static defaultProps = {
    includeColorDropDown: true
  };

  static propTypes = {
    productType: PropTypes.string,
    genders: PropTypes.arrayOf(PropTypes.string),
    styleList: PropTypes.array,
    selectedStyle: PropTypes.object,
    selectedSizing: PropTypes.object,
    sizing: PropTypes.object,
    dimensionValidation: PropTypes.object,
    onStockChange: PropTypes.func,
    onAddToCart: PropTypes.func,
    includeColorDropDown: PropTypes.bool,
    isSelectSizeTooltipVisible: PropTypes.bool,
    isSelectSizeTooltipHighlighted: PropTypes.bool.isRequired
  };

  onColorChange = ({ target: { value, selectedIndex, options } }) => {
    const { selectedSizing, onStockChange } = this.props;
    onStockChange(value, selectedSizing, { label: 'color', value });
    const selectedColorText = options[selectedIndex].text;
    const eventData = {
      dimension: 'COLOR_DIMENSION',
      dimensionId: value,
      dimensionLabel: selectedColorText,
      sourcePage: 'PRODUCT_PAGE'
    };

    track(evProductDimensionSelected, eventData);
  };

  onSizeChange = (options, event) => {
    const { productId, selectedSizing, selectedStyle, onStockChange, sizing } = this.props;
    const newSizes = Object.assign({}, selectedSizing, {});
    const { target: { name, value } } = event;
    const trackLabel = event.target.getAttribute('data-track-label');
    newSizes[name] = value;
    onStockChange(selectedStyle.styleId, newSizes, { label: trackLabel, value });
    const selectedOption = options.find(option => option.id === value);
    if (selectedOption) {
      const eventData = {
        dimensionDirty: sizing.dimensionIdToName[name],
        dimensionId: selectedOption.id,
        dimensionLabel: selectedOption.value,
        sourcePage: 'PRODUCT_PAGE'
      };

      const completedSizing = Object.assign({}, selectedSizing, { [name]: value });
      if (ProductUtils.isSizeSelectionComplete(sizing, completedSizing)) {
        eventData.stock = ProductUtils.getStockBySize(sizing.stockData, selectedStyle.colorId, completedSizing);
      }

      track(evProductDimensionSelected, eventData);
      trackEvent('TE_PDP_SIZING', `${productId}:SizeSelected:${selectedOption.value}`);
    } else {
      trackError(`Unable to find matching option for size id ${value} on productId ${productId}`, 'ERROR');
    }
  };

  render() {
    const {
      onAddToCart,
      addToCartAction,
      styleList,
      selectedStyle,
      sizing,
      selectedSizing,
      productType,
      genders,
      dimensionValidation,
      onShowSelectSizeTooltip,
      onHideSelectSizeTooltip,
      includeColorDropDown,
      isSelectSizeTooltipVisible,
      isSelectSizeTooltipHighlighted,
      showSizeGender,
      showSizeCharts,
      sizingPredictionId,
      isOnDemandEligible,
      hydraSizeRecommenderTooltip,
      hasRecommendedSizing,
      location
    } = this.props;
    const isNotGiftCard = !ProductUtils.isGiftCard(productType);
    const { productId } = selectedStyle || {};
    return (
      <form method="POST" action={addToCartAction} onSubmit={onAddToCart}>
        {includeColorDropDown && <ColorChooser
          styleList={styleList}
          selectedStyle={selectedStyle}
          onColorChange={this.onColorChange}
          showStyleChooserPrefix={showStyleChooserPrefix}
          isGiftCard={!isNotGiftCard}
          showColorLabel={true}
        />}
        {isNotGiftCard &&
          <SizingChooser
            productId={productId}
            productType={productType}
            genders={genders}
            sizing={sizing}
            selectedSizing={selectedSizing}
            dimensionValidation={dimensionValidation}
            sizingPlaceholder={sizingPlaceholder}
            onSizeChange={this.onSizeChange}
            showSizeGender={showSizeGender}
            showSizeCharts={showSizeCharts}
            isSelectSizeTooltipVisible={isSelectSizeTooltipVisible}
            isSelectSizeTooltipHighlighted={isSelectSizeTooltipHighlighted}
            sizingPredictionId={sizingPredictionId}
            isOnDemandEligible={isOnDemandEligible}
            hydraSizeRecommenderTooltip={hydraSizeRecommenderTooltip}
            hasRecommendedSizing={hasRecommendedSizing}
            location={location}
          />
        }
        <AddToCart
          productStyle={selectedStyle}
          selectedSizing={selectedSizing}
          sizing={sizing}
          addToCartText={addToCartText}
          lowStockMessage={lowStockMessage}
          onShowSelectSizeTooltip={onShowSelectSizeTooltip}
          onHideSelectSizeTooltip={onHideSelectSizeTooltip}
          isGiftCard={!isNotGiftCard}/>
      </form>
    );
  }
}

export default StylePicker;
